import { useQuery } from "@tanstack/react-query";
import { vinculosApi } from "../api/vinculosApi";

export function useVinculosQuery() {
  return useQuery({ queryKey: ["vinculos"], queryFn: vinculosApi.list });
}
